module.exports = __webpack_public_path__ + "img/it-82.dc7a07c2.svg";